import { useState, useEffect } from "react";
import axios from "axios";

export const useApps = () => {
  const [sidebarIcons, setSidebarIcons] = useState([]);
  const [loadingApps, setLoadingApps] = useState(false);

  useEffect(() => {
    const getApps = async () => {
      try {
        setLoadingApps(true);
        const { data } = await axios.get(`${process.env.REACT_APP_Auth_API_BASE_URL}/app`);
        setSidebarIcons(data?.map(app => ({
          _id: app?._id,
          name: app?.name,
          titleAr: app?.titleAr,
          titleEn: app?.titleEn,
          descAr: app?.descAr,
          descEn: app?.descEn,
          icon: app?.icon,
          img: app?.img,
          baseUrl: app?.baseUrl,
          status: app?.status,
        })));
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingApps(false);
      }
    };

    getApps();
  }, []);

  return { sidebarIcons, loadingApps };
};
